module.exports = __webpack_public_path__ + "static/media/manualPMIcon.6d53bc97.svg";